// extracted by mini-css-extract-plugin
export default {"pageLabelItemList":"PageLabelItemList_pageLabelItemList__JIJYh","pageLabelItem":"PageLabelItemList_pageLabelItem__stIsb"};